import { OrderApi } from '../api/OrderApi'
import { Order } from '../core/Order'
import { plansStore } from '../store/plansStore'
import { orderStore } from '../store/orderStore'
import { GatewayCheckout } from '../services/GatewayCheckout'

export const extraAction = {
	props: {
		updating: {

		},
		extraParams : {

		},
		extraExecuted: {

		},
		maxAvailable: {
			type: Number,
			default: 999
		}
	},

  data() {
    return {
      oldExtras: {}
    }
  },
	computed: {
		user () {
			return this.$root.user
		}
	},

  mounted () {
    if (this.order) {
      for (let e in this.order.extras) {
        this.oldExtras[this.order.extras[e].id] = this.order.extras[e].quantity;
      }
    }
  },

	methods: {
		$_extraAction_extraAvailable (extra) {
			const extraInOrder = (extra) => {
				if (!this.order) return false
				var e = this.order.getExtraByAttribute('id', extra.id)
				if (!e) return false
				return e || e.quantity !== 0
			}

			const extraInStock = (extra) => {
				return this.$_extraAction_getVirtualStock(extra) > 0
			}

			return extraInOrder(extra) || extraInStock(extra)
		},

    $_extraAction_getVirtualStock(extra) {
      let stock = extra.stock;

      if (typeof this.oldExtras[extra.id] !== "undefined" && extra.stock <= this.oldExtras[extra.id]) {
        return this.oldExtras[extra.id];
      }

      return extra.stock;
    },

		$_extraAction_outOfStock (extra) {
			var e = this.order.getExtraByAttribute('id', extra.id)
      let stock = this.$_extraAction_getVirtualStock(extra);

      if (!e) {
        return stock <= 0;
      }

      let tot = stock - e.quantity;


			return tot <= 0
		},

		$_extraAction_quantityExtraInOrder (id) {
			if (!this.order) return

			var e = this.order.getExtraByAttribute('id', id)
			if (e) { return e.quantity }

      return 0
		},

		$_extraAction_add (extra) {
			if (this.updating) return

			let callback = () => {
				this.$_extraAction_addInner(extra)
			}
			if (!GatewayCheckout.isGuestAllowed(callback)) {
				this.$emit('update:updating', false)
				return;
			}
			callback()
		},
		$_extraAction_addInner(extra) {

			var params = { __preserve: 1 }
			var order = this.order
			var e = order.getExtraByAttribute('id', extra.id)

			if (this.$_extraAction_getVirtualStock(extra) <= 0) return

			if (!Array.isArray(order.extras)) {
				order.extras = Object.values(order.extras)
			}

			if (e && e.quantity === this.maxAvailable) {
				return;
			}

			window.dispatchEvent(new CustomEvent('quomi.event', { 
		        bubbles: true, 
		        detail: {
		          name: 'updateProductQuantity',
		          vars: {
		          	product: extra,
		          	quantity: 1,
		          	order: order
		          }
		        } 
		     }));

			if (!e) { order.extras.push({id: extra.id, quantity: 1}) } else { e.quantity++ }


			params.extra = order.extras.map(function (v) {
				return { id: v.id, quantity: v.quantity }
			})

			this.$emit('update:extraParams', params.extra)
			this.$emit('update:updating', true)


			this.$_extraAction_updateOrder({ params: params }).then(response => {
				this.$emit('update:updating', false)
				this.$emit('update:actionExecuted', true)

				this.flash = '<i class="fas fa-check"></i> Ordine aggiornato'
				this.state = 'success'
			
				setTimeout(() => {
					this.flash = null
				}, 2000)			
	

			}).catch(response => {
				this.$emit('update:updating', false)
				if (e) { e.quantity-- }
			})
		},

		$_extraAction_remove (extra) {
			if (this.updating) return

			var params = { __preserve: 1 }
			var order = this.order
			var e = order.getExtraByAttribute('id', extra.id)

			if (!e) { return }

			window.dispatchEvent(new CustomEvent('quomi.event', { 
		        bubbles: true, 
		        detail: {
		          name: 'updateProductQuantity',
		          vars: {
		          	product: extra,
		          	quantity: -1,
		          	order: order
		          }
		        } 
		     }));

			e.quantity--


			if (e.quantity <= 0) { order.removeExtraByAttribute('id', e.id) }

			params.extra = order.extras.map(function (v) {
				return { id: v.id, quantity: v.quantity }
			})

			if (params.extra.length <= 0) {
				params.extra = []
			}

			this.$emit('update:extraParams', params.extra)
			this.$emit('update:updating', true)

			this.$_extraAction_updateOrder({ params: params }).then(response => {
				this.$emit('update:updating', false)
				this.$emit('update:actionExecuted', true)
				
				this.flash = '<i class="fas fa-check"></i> Ordine aggiornato'
				this.state = 'success'
			
				setTimeout(() => {
					this.flash = null
				}, 2000)

				
			}).catch(response => {
				this.$emit('update:updating', false)
				if (e) { e.quantity++ }

			})
		},

		$_extraAction_removeAll (item) {
			if (this.updating) return

			var params = { __preserve: 1 }
			var order = this.order
			var e = order.getExtraByAttribute('id', item.id)

			if (!e) return
			for (let i = 0, n = e.quantity; i < n; i++) {
				e.quantity--
				if (e.quantity <= 0) { order.removeExtraByAttribute('id', e.id) }
			}

			params.extra = order.extras.map(function (v) {
				return { id: v.id, quantity: v.quantity }
			})

			if (params.extra.length <= 0) {
				params.extra = []
			}
			
			this.$emit('update:extraParams', params.extra)
			this.$emit('update:updating', true)

			this.$_extraAction_updateOrder({ params: params }).then(response => {
				this.$emit('update:updating', false)
				this.$emit('update:actionExecuted', true)
			}).catch(response => {
				this.$emit('update:updating', false)

				if (e) {
					var n = e.quantity
					for (let i = 0; i < n; i++) {
						e.quantity++
					}

				}

			})
		},

		listenChangePlan (people) {
			return plansStore.findPlan({
				people: people,
				meals: Object.values(this.recipes).map(a => a.quantity).reduce((a, b) => a + b, 0)
			})
		},


		$_extraAction_updateOrder (vars) {
			if (!this.order) return
			var token = this.order.token
			var params = vars ? vars.params : {}
			var om = new OrderApi()


			let recipes = {};

			for (let r in this.order.recipes) {
				r = this.order.recipes[r]
				recipes[r.id] = { id: r.id, quantity: r.quantity }
			}

			params.recipes_id = recipes;
			
			if (params.extra) {
				orderStore.updateOrderParam({ param: 'extra', value: params.extra })
			}


			this.$emit('changed')

			params.plan_id = this.order.plan_id

			let t = Promise.resolve();

			if (typeof this.recipes !== 'undefined') {
				/*t = this.listenChangePlan(this.order.plan.people).then(plan => {
					params.plan_id = plan.id
				})*/
			}

			return t.then(() => {
				return om.updateOrCreate(token, params)
			}).then(response => {
				var order = new Order(response.body.data.resource)
				this.$emit('update:order', order)
	
				window.order = order

				var user = this.user
				user.order = order
				this.$root.updateUser(user)
        orderStore.saveOrderToStore(response)
			}).catch(response => {

			})
		}
	}
}
